var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFireworksOverly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 514,
    height: 155,
    viewBox: "0 0 514 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 514,
    height: 155,
    transform: "translate(0 33)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fireworks-overly9",
    transform: "translate(0 -33)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    opacity: 0.957
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M401.59,51.378c1.338,0,2.425.758,2.425,1.692s-1.087,1.692-2.425,1.692-2.424-.758-2.424-1.692S400.252,51.378,401.59,51.378Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M393.075,160.129a1.761,1.761,0,1,1-1.977,1.747A1.875,1.875,0,0,1,393.075,160.129Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M90.859,89.051a1.879,1.879,0,1,1-2.09,1.868A1.989,1.989,0,0,1,90.859,89.051Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    opacity: 0.908
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M156.8,152.86a1.8,1.8,0,1,1-1.735,1.8A1.771,1.771,0,0,1,156.8,152.86Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M202.569,45.293c3.324,0,6.023.688,6.023,1.535s-2.7,1.535-6.023,1.535-6.024-.688-6.024-1.535S199.244,45.293,202.569,45.293Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M342.568,38.4c2.15,0,3.9.487,3.9,1.088s-1.746,1.088-3.9,1.088-3.9-.487-3.9-1.088S340.418,38.4,342.568,38.4Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M140.865,71.4c2.876,0,5.211.759,5.211,1.694s-2.335,1.694-5.211,1.694-5.211-.759-5.211-1.694S137.989,71.4,140.865,71.4Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M343.554,142.682c2.672,0,4.842,1.1,4.842,2.453s-2.17,2.454-4.842,2.454-4.841-1.1-4.841-2.454S340.882,142.682,343.554,142.682Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M279.214,71.52l-5.155-1.912,2.834-4.6,5.155,1.912Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M293.188,136.459l-4.626-2.014,2.544-4.849,4.625,2.014Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M65.846,175.1,63,173.883l1.563-2.936,2.842,1.219Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M124.6,78.278l-4.057-1.333,2.231-3.21,4.057,1.333Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M384.854,115.874l-2.706-2.052,1.488-4.94,2.706,2.051Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M181.5,118.525l-3.952-2.774,2.173-6.682,3.952,2.775Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M256,85.993l6.562,4.479H249.439Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M253.375,178.613l8.26,4.436h-16.52Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M386.8,60.572l5.577,5.487H381.227Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M132.5,113.13l5.471,3.34H127.029Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M348.93,158.571l5.746,3.267H343.184Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M170.128,85.491l3.107,3.895h-6.214Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M400.842,183.115c-.268,1.194-2.535,2.148-5.059,2.129s-4.358-1-4.09-2.2,2.534-2.147,5.059-2.128S401.109,181.921,400.842,183.115Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    opacity: 0.908
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M157.058,182.271c-.1.438-1.823.782-3.844.767s-3.582-.384-3.483-.822,1.822-.782,3.844-.767S157.157,181.832,157.058,182.271Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M330.951,48.743c-.11.484-2.166.862-4.589.844s-4.3-.426-4.19-.91,2.166-.862,4.589-.844S331.061,48.259,330.951,48.743Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M184.4,80.175c-.206.91-2.483,1.633-5.081,1.613s-4.539-.774-4.333-1.684,2.483-1.633,5.081-1.613S184.6,79.265,184.4,80.175Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M424.868,102.481c-.262,1.177-2.338,2.119-4.632,2.1s-3.944-.987-3.682-2.164,2.338-2.119,4.633-2.1S425.131,101.3,424.868,102.481Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    opacity: 0.989
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M458.1,161.637c-.234,1.07-1.744,1.928-3.371,1.916s-2.758-.891-2.524-1.961,1.745-1.929,3.372-1.917S458.337,160.566,458.1,161.637Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    opacity: 0.844
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M363.479,73.844c-.055.245-1.473.433-3.165.421s-3.021-.222-2.966-.467,1.473-.433,3.165-.421S363.534,73.6,363.479,73.844Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    opacity: 0.957
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M191.984,163.289c-.123.543-1.486.974-3.04.963s-2.717-.462-2.594-1.005,1.485-.973,3.04-.962S192.107,162.747,191.984,163.289Z",
    fill: "#ff1a61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M354.223,134.676l3.209-2.839,5.841,1.619-3.209,2.838Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M214.5,136.408l3.838-3.382,6.995,1.928-3.838,3.383Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M133.629,39.14l2.888-2.627,5.214,1.5-2.888,2.627Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    opacity: 0.989
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M345.029,61.9l5.147-2.146L361.1,61.04l-5.147,2.146Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    opacity: 0.844
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M259.575,183.336l2.984-1.669,6.05.975-2.985,1.669Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M254.867,88.206l4.186-1.486,9.065.9-4.186,1.486Z",
    fill: "#ffe41d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    opacity: 0.989
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M330.566,121.567l-4.995,1.453.653-2.977Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M109.415,115.209l-4.7,2.234.939-4.534Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M383.43,180.36l-4.586,2.283.952-4.631Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M255.505,63.953l-6.264,3.033,1.271-6.154Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M152.79,160.342l-8.847,2.23,1.017-4.587Z",
    fill: "#2ab6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M335.631,85.8l-7.1.839.406-1.78Z",
    fill: "#50e3c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M169.51,136.046c-1.32,1.071-2.719,2.1-4.132,3.027",
    fill: "none",
    stroke: "#ff1a61",
    strokeWidth: 0.443
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M302.581,160.188a29.723,29.723,0,0,1,7.9,1.891",
    fill: "none",
    stroke: "#ffe41d",
    strokeWidth: 4.221
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M169.007,60.9A36.951,36.951,0,0,1,158.77,54.5",
    fill: "none",
    stroke: "#b91dff",
    strokeWidth: 4.239
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M340.106,114.719a49.8,49.8,0,0,1,10.328.328",
    fill: "none",
    stroke: "#7ed321",
    strokeWidth: 3.318
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M104.739,78.185a177.98,177.98,0,0,1-20.378,1.256",
    fill: "none",
    stroke: "#50e3c2",
    strokeWidth: 7.693
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M317.591,142.545a99.8,99.8,0,0,1,12.861.874",
    fill: "none",
    stroke: "#ff1a61",
    strokeWidth: 5.539
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M365.426,90.36a44.5,44.5,0,0,1-.74-7",
    fill: "none",
    stroke: "#ffe41d",
    strokeWidth: 8.035
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M155.62,143.642c3.295,4.2,5.578,8.235,4.323,11.793",
    fill: "none",
    stroke: "#b91dff",
    strokeWidth: 3.846
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M265.064,79.753c-5.017-1.15-9.42-2.434-11.474-4.634",
    fill: "none",
    stroke: "#7ed321",
    strokeWidth: 2.893
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireworksOverly);
export default __webpack_public_path__ + "static/media/fireworks-overly.192bec90340a273d1c8c44202553aa77.svg";
export { ForwardRef as ReactComponent };